<template>
  <div class="counter">
    <el-dialog
      width="110rem"
      class="dialog-one"
      v-model="manualDialog"
      :show-close="false"
      @closed="handleNestedDialogClosed"
    >
      <el-tabs v-model="manualOrderInfo.manualActiveName" type="card">
        <el-tab-pane :label="$t('MANUAL.MANUALORDERLIST')" name="first">
          <el-row>
            <el-col :span="4" class="search-input">
              <div>{{ $t("MANUAL.SEARCHCLIENT") }}</div>
              <el-input v-model="manualOrderInfo.customerName"></el-input>
            </el-col>
            <el-col :span="4" class="search-input">
              <div>{{ $t("MANUAL.CONTACTNAME") }}</div>
              <el-input v-model="manualOrderInfo.contactName"></el-input>
            </el-col>
            <el-col :span="4" class="search-input">
              <div>{{ $t("MANUAL.GUESTNAME") }}</div>
              <el-input v-model="manualOrderInfo.guestName"></el-input>
            </el-col>
            <el-col :span="4" class="search-input">
              <div>{{ $t("MYORDER.OrderNo") }}</div>
              <el-input v-model="manualOrderInfo.manualCode"></el-input>
            </el-col>
            <el-col
              :span="2"
              class="search-btn"
              @click.native="getManualOrder(1)"
            >
              <el-button>{{ $t("USERDIALOG.BTNSEARCH") }}</el-button>
            </el-col>
          </el-row>
          <div>
            <el-table :data="manualOrderInfo.manualOrderData">
              <el-table-column
                prop="customerName"
                :label="$t('MANUAL.SEARCHCLIENT')"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="bookingCode"
                :label="$t('MYORDER.OrderNo')"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="hotelNameCn"
                :label="$t('MANUAL.HOTELNAMECN')"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="hotelNameEn"
                :label="$t('MANUAL.HOTELNAMEEN')"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="processors"
                :label="$t('MANUAL.PROCESSORS')"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="guestName"
                :label="$t('CONFIRMATION.TRAVLERNAME')"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="cityName"
                :label="$t('ORDERLIST.City')"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="checkInDate"
                :label="$t('CONFIRMATION.CHECKINDATE')"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="checkOutDate"
                :label="$t('CONFIRMATION.CHECKOUTDATE')"
                align="center"
              ></el-table-column>
              <el-table-column width="100" :label="$t('USERDIALOG.OPERATION')">
                <template #default="scope">
                  <el-button
                    type="text"
                    size="small"
                    :disabled="!scope.row.isAllowedActions"
                    @click="SelectManualOrder(scope.row)"
                  >
                    {{ $t("USERDIALOG.SELECT") }}
                  </el-button>
                  <el-button
                    :disabled="!scope.row.isAllowedActions"
                    @click="deleteRow(scope.row)"
                    type="text"
                    size="small"
                  >
                    {{ $t("ORDERLIST.DELETE") }}
                  </el-button>
                  <el-button
                    :disabled="!scope.row.isAllowedActions"
                    @click="openOperationLog(scope.row)"
                    type="text"
                    size="small"
                  >
                    {{ $t("ORDERLIST.OPERATIONLOG") }}
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <el-row style="float: right; margin: 2%">
            <el-pagination
              background
              layout="total,prev, pager, next"
              :total="manualOrderInfo.pagination.total"
              :page-size="manualOrderInfo.pagination.pageSize"
              :current-page="manualOrderInfo.pagination.currentPage"
              @current-change="pageChange_manualOrderDialog"
            >
            </el-pagination>
          </el-row>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
    <!--订单操作日志el-dialog-->
    <el-dialog
      width="98rem"
      class="dialog-one"
      v-model="operationLogInfo.dialogClient"
      :show-close="false"
    >
      <!-- <Loading
        :loading="operationLogInfo.operationLogloading"
        :isRelativeBrowserWin="false"
      /> -->
      <el-tabs v-model="operationLogInfo.clientActiveName" type="card">
        <el-tab-pane
          :label="$t('OPERATIONLOG.OrderOperationDetails')"
          name="first"
        >
          <el-table :data="operationLogInfo.clientData">
            <el-table-column
              prop="CreateDateTime"
              align="center"
              :label="$t('OPERATIONLOG.CreateTime')"
              width="200"
            ></el-table-column>
            <el-table-column
              prop="Operation"
              align="center"
              :label="$t('OPERATIONLOG.Operation')"
              width="200"
            ></el-table-column>
            <el-table-column
              prop="Description"
              align="center"
              :label="$t('OPERATIONLOG.Description')"
              width="300"
            ></el-table-column>
            <el-table-column
              prop="UserID"
              align="center"
              :label="$t('OPERATIONLOG.CreateById')"
              width="100"
            ></el-table-column>
            <el-table-column
              prop="Type"
              align="center"
              :label="$t('OPERATIONLOG.Type')"
              width="150"
            ></el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
  </div>
</template>
<script>
import {
  getManualOrderList,
  saveManual,
  getOperationLog,
  selectManualOrder,
} from "../../api/bookingData.js";
import { formatDateTime } from "../../utils/utils.js";
export default {
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      manualOrderInfo: {
        manualActiveName: "first",
        customerName: "",
        contactName: "",
        guestName: "",
        manualOrderData: [],
        pagination: {
          total: 0, //总数
          pageSize: 15,
          currentPage: 1,
        }, //分页信息
        manualCode: "",
      },
      confirmMsg: "", //提示消息内容
      confirmFlag: false, //提示框是否弹出
      operationLogInfo: {
        operationLogloading: false,
        dialogClient: false,
        clientActiveName: "first",
        clientData: [],
      },
      time: 0,
      intervalId: null,
      manualDialog: false,
    };
  },
  watch: {
    isOpen(newVal) {
      if (newVal) {
        this.manualDialog = this.isOpen;
        this.getManualOrder(1);
      }
    },
  },
  mounted() {
    this.getManualOrder(1);
    this.manualDialog = this.isOpen;
  },
  methods: {
    handleNestedDialogClosed() {
      this.$emit("child-dialog-closed");
    },
    getManualOrder(currPage) {
      let Params = {
        params: {
          customerName: this.manualOrderInfo.customerName,
          contactName: this.manualOrderInfo.contactName,
          guestName: this.manualOrderInfo.guestName,
          bookCode:this.manualOrderInfo.manualCode,
          pageSize: this.manualOrderInfo.pagination.pageSize,
          pageIndex: currPage,
        },
      };
      getManualOrderList(Params).then((res) => {
        if (res.code == 200) {
          let data = res.data.manualOrderList.filter((item) => {
            item.checkInDate = formatDateTime(item.checkInDate, "YYYY-MM-DD");
            item.checkOutDate = formatDateTime(item.checkOutDate, "YYYY-MM-DD");
            return item;
          });
          this.manualOrderInfo.pagination.total = res.data.pagination.total; //总数
          this.manualOrderInfo.pagination.pageSize =
            res.data.pagination.pageLimit;
          this.manualOrderInfo.pagination.currentPage =
            res.data.pagination.pageNum;
          this.manualOrderInfo.manualOrderData = data;
        }
      });
    },
    pageChange_manualOrderDialog(currPage) {
      this.getManualOrder(currPage);
    },
    async openOperationLog(row) {
      var arrTemp = [];
      let that = this;
      this.operationLogInfo.clientData = [];
      this.operationLogInfo.dialogClient = true;
      //that.operationLogInfo.operationLogloading = true;
      let operationLogParam = {
        params: {
          bookingCode: row.manualCode,
        },
      };
      await getOperationLog(operationLogParam)
        .then((res) => {
          if (res.code == 200) {
            if (res.data.orderOperationLogInfo != null) {
              for (var i = 0; i < res.data.orderOperationLogInfo.length; i++) {
                var response = res.data.orderOperationLogInfo[i];
                const item = {
                  CreateDateTime: formatDateTime(response.createDateTime,"YYYY-MM-DD HH:mm:ss"),
                  Description: response.description,
                  UserID: response.userID,
                  Operation: response.operation,
                  Type: response.type,
                };
                arrTemp.push(item);
              }
            }
            that.operationLogInfo.clientData = arrTemp;
          }
          //that.operationLogInfo.operationLogloading = false;
        })
        .catch(function (error) {
          //that.operationLogInfo.operationLogloading = false;
          console.log("订单操作日志 请求失败", error);
        });
    },
    deleteRow(row) {
      this.$confirm("确定要删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = {
          manualCode: row.manualCode,
          customerID: row.customerID,
          customerName: row.customerName,
          contactName: row.contactName,
          contactTel: row.contactTel,
          contactEmail: row.contactEmail,
          guestName: row.guestName,
          guestTel: row.guestTel,
          guestEmail: row.guestEmail,
          cityCode: row.cityCode,
          cityName: row.cityName,
          checkInDate: row.checkInDate,
          CheckOutDate: row.CheckOutDate,
          isdel: 1,
        };
        saveManual(params).then((res) => {
          if (res.code == 200) {
            if (res.data.status) {
              this.$emit("openConfirmFlag", "删除成功");
              this.getManualOrder(1);
            } else {
              this.$emit("openConfirmFlag", "删除失败");
            }
          }
        });
      });
    },
    startTimer(manualCode) {
      // 防止重复启动定时器
      if (this.intervalId) return;

      this.intervalId = setInterval(() => {
        this.RecordingManualOrder(manualCode);
      }, 10000); // 每秒更新一次
    },
    stopTimer() {
      clearInterval(this.intervalId);
      this.intervalId = null;
    },
    SelectManualOrder(row) {
      let params = {
        bookCode: row.manualCode,
      };
      this.manualDialog = false;
      selectManualOrder(params).then((res) => {
        if (res.code == 200) {
          if (res.data.error.code == 0) {
            if (!res.data.isAllowedActions) {
              let confirmMsg = "当前订单正被" + res.data.action + "操作";
              this.$emit("openConfirmFlag", confirmMsg);
            } else {
              // 调用父组件的方法
              this.startTimer(row.manualCode);
              this.$emit("selectManualOrder", row);
            }
          } else {
            this.$emit("openConfirmFlag", "选择失败,请重新操作");
          }
        }
      });
    },
    RecordingManualOrder(manualCode) {
      let params = {
        bookCode: manualCode,
      };
      selectManualOrder(params);
    },
  },
  beforeDestroy() {
    // 确保组件销毁时清除定时器
    this.stopTimer();
  },
};
</script>
<style lang="stylus" scoped>
.search-input {
  margin-left: 5%;
}
.search-btn {
  margin: 2% 5%;
  button {
    padding: 7px 20px;
    border: 1px solid $btn-bg-color;
    color: $btn-bg-color;
  }
}
</style>
